import React, { useState, useMemo } from 'react'
import styles from './style.module.scss'
import track from '@assets/images/f1/img/track.png'
import Image from 'next/future/image'
import prevBtn from '@assets/images/f1/icons/prevBtn.png'
import nextBtn from '@assets/images/f1/icons/nextBtn.png'
import PropTypes from 'prop-types'
import flag from '@assets/images/f1/icons/countryFlag.png'

export function formatDateRange(startDateStr, endDateStr) {
  const startDate = new Date(startDateStr)
  const endDate = new Date(endDateStr)

  const month = startDate.toLocaleString('default', { month: 'short' })
  const startDay = String(startDate.getDate()).padStart(2, '0')
  const endDay = String(endDate.getDate()).padStart(2, '0')

  return `${month} ${startDay}-${endDay}`
}

const EventSchedule = ({ raceData }) => {
  const RaceData = useMemo(() => {
    const scheduledRaceData = raceData?.data?.filter(race => race?.eRaceStatus === 'Scheduled')
    const sortedRaceData = (scheduledRaceData ?? []).sort((a, b) => new Date(a.dFirstPractice) - new Date(b.dFirstPractice))
    const finishedRaceData = (raceData?.data ?? [])?.filter(race => race?.eRaceStatus === 'Finished')
    return [...sortedRaceData, ...finishedRaceData]
  }, [raceData])

  const [currentIndex, setCurrentIndex] = useState(0)
  const handlePrev = () => {
    setCurrentIndex(prev => (prev > 0 ? prev - 1 : RaceData.length - 1))
  }

  const handleNext = () => {
    setCurrentIndex(prev => (prev < RaceData.length - 1 ? prev + 1 : 0))
  }

  const currentEvent = RaceData?.[currentIndex]

  return (
    <div className={styles.events}>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <Image src={currentEvent?.oCircuit?.sCountryFlag || flag} alt={currentEvent?.sRaceName} width={54} height={40} />
        <div className={styles.text}>{formatDateRange(currentEvent?.dFirstPractice, currentEvent?.dDate)}</div>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <button onClick={handlePrev}>
          <Image src={prevBtn} alt="Previous" width={32} height={32} />
        </button>
        <Image
          src={currentEvent?.oCircuit?.sImgUrl === 'demoImg.png' ? track : currentEvent?.oCircuit?.sImgUrl || track}
          alt="Track"
          width={176}
          height={100}
        />
        <button onClick={handleNext}>
          <Image src={nextBtn} alt="Next" width={32} height={32} />
        </button>
      </div>

      <div className="d-flex flex-column text-center align-items-center">
        <h3 className={styles.nation}>{currentEvent?.oCircuit?.oLocation?.sCountry}</h3>
        <p className={styles.title}>{currentEvent?.sRaceName}</p>
      </div>
    </div>
  )
}

EventSchedule.propTypes = {
  raceData: PropTypes.array
}

export default EventSchedule
